<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <span>Permohonan</span>
                </div>
            </div>


            <!-- Under Development Notice -->
            <!-- <div class="row justify-content-center">
                <div class="col-12 col-lg-6">
                    <div class="under-development-card">
                        <div class="dev-icon">
                            <i class="fas fa-hard-hat"></i>
                        </div>
                        <h3>Dalam Pembangunan</h3>
                        <p>Laman permohonan mahasiswa sedang dalam proses pembangunan. 
                           Sila hubungi pejabat akademik atau fakulti masing-masing untuk sebarang permohonan.</p>
                        <div class="dev-features">
                            <div class="coming-soon-item">
                                <i class="fas fa-scroll"></i>
                                <span>Mohon Ijazah</span>
                            </div>
                            <div class="coming-soon-item">
                                <i class="fas fa-umbrella-beach"></i>
                                <span>Mohon Cuti</span>
                            </div>
                            <div class="coming-soon-item">
                                <i class="fas fa-clipboard-list"></i>
                                <span>Mohon Periksa Susulan</span>
                            </div>
                            <div class="coming-soon-item">
                                <i class="fas fa-file-signature"></i>
                                <span>Mohon Surat Akuan</span>
                            </div>
                        </div>
                        <router-link to="/" class="btn-back-home">
                            <i class="fas fa-arrow-left"></i> Kembali ke Laman Utama
                        </router-link>
                    </div>
                </div>
            </div> -->

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Permohonan Mahasiswa</h2>
                <p class="page-subtitle">Layanan Permohonan Dokumen & Administrasi</p>
                <p class="page-description">
                    Ajukan permohonan untuk berbagai keperluan administrasi akademik Anda dengan mudah dan cepat
                </p>
            </div>
            
            <!-- Application Menu Grid -->
            <!-- <div class="row justify-content-center"> -->
                <!-- Mohon Ijazah -->
                 <div class="col-6 col-lg-3 col-md-4 mb-4">
                     <router-link :to="{name: 'application-certificate'}" class="card-link">
                         <div class="theme-card fade-in">
                             <div class="icon-wrapper">
                                 <i class="fas fa-scroll"></i>
                             </div>
                             <div class="card-content">
                                 <h3 class="card-title">Mohon Ijazah</h3>
                                 <p class="card-description">Permohonan salinan ijazah & transkrip</p>
                             </div>
                         </div>
                     </router-link>
                 </div>

                <!-- Mohon Cuti -->
                <!-- <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'application-leave'}" class="card-link">
                        <div class="theme-card fade-in">
                            <div class="icon-wrapper">
                            <i class="fas fa-umbrella-beach"></i>
                        </div>
                        <div class="card-content">
                            <h3 class="card-title">Mohon Cuti</h3>
                            <p class="card-description">Permohonan cuti akademik semester</p>
                        </div>
                    </div>
                </router-link>
                </div> -->
                <!-- Mohon Periksa Susulan -->
                <!-- <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'application-makeup-exam'}" class="card-link">
                        <div class="theme-card fade-in">
                            <div class="icon-wrapper">
                                <i class="fas fa-clipboard-list"></i>
                        </div>
                        <div class="card-content">
                            <h3 class="card-title">Mohon Periksa Susulan</h3>
                            <p class="card-description">Permohonan ujian susulan</p>
                        </div>
                    </div>
                </router-link>
                </div> -->

                <!-- Mohon Surat Akuan -->
                <!-- <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'application-certificate-letter'}" class="card-link">
                        <div class="theme-card fade-in">
                            <div class="icon-wrapper">
                            <i class="fas fa-file-signature"></i>
                        </div>
                        <div class="card-content">
                            <h3 class="card-title">Mohon Surat Akuan</h3>
                            <p class="card-description">Permohonan surat keterangan mahasiswa</p>
                        </div>
                    </div>
                </router-link>
                </div> -->
            <!-- </div> -->

            <!-- Section Divider -->
            <!-- <div class="section-divider"></div> -->

            <!-- Information Section -->
            <!-- <div class="page-content">
                <div class="info-section">
                    <div class="info-card slide-in-right">
                        <h4 class="info-card-title">
                            <i class="fas fa-info-circle"></i> Informasi Penting
                        </h4>
                        <p class="info-card-text">
                            Pastikan data profil Anda sudah lengkap sebelum mengajukan permohonan. 
                            Proses verifikasi memerlukan waktu 3-5 hari kerja. Anda akan menerima 
                            notifikasi melalui email setelah permohonan diproses.
                        </p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'ApplicationIndex',
    metaInfo: {
        title: 'Permohonan Mahasiswa'
    },
    mounted() {
        // Add fade-in animation on mount
        const cards = document.querySelectorAll('.theme-card');
        cards.forEach((card, index) => {
            setTimeout(() => {
                card.style.animationDelay = `${index * 0.1}s`;
            }, 0);
        });
    }
}
</script>

<style scoped>
/* Import theme styles inline for this component */
/* You can remove these if theme.css is imported globally */
    .under-development-card {
    background: var(--bg-white);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-md);
    padding: 40px 30px;
    text-align: center;
}

.dev-icon {
    width: 100px;
    height: 100px;
    background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
}

.dev-icon i {
    font-size: 2.5rem;
    color: var(--text-white);
}

.under-development-card h3 {
    color: var(--text-primary);
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 12px;
}

.under-development-card p {
    color: var(--text-secondary);
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 30px;
}

.dev-features {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-bottom: 30px;
}

.coming-soon-item {
    background: #f8f9fa;
    padding: 16px;
    border-radius: var(--border-radius-sm);
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--text-secondary);
    font-size: 0.9rem;
}

.coming-soon-item i {
    color: var(--primary-color);
    font-size: 1.1rem;
}

.btn-back-home {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: var(--primary-gradient);
    color: var(--text-white);
    padding: 12px 24px;
    border-radius: var(--border-radius-sm);
    text-decoration: none;
    font-weight: 600;
    transition: var(--transition-normal);
}

.btn-back-home:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
    color: var(--text-white);
}

@media (max-width: 576px) {
    .dev-features {
        grid-template-columns: 1fr;
    }
}

</style>
